<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col>
        <router-link :to="{ name: 'information_payment_list', params: { search: search } }" class="btn btn-ptc1" tag="button">返回</router-link>
      </b-col>
      <b-col class="text-center title">第三方支付訂單資訊>明細</b-col>
      <b-col>
        <div class="float-right">
        </div>
      </b-col>
    </b-row>
    <div id="func-content">
      <b-card class="bg-default-card">
        <div class="row">
          <div class="row col-lg-12">
            <div class="col-md-4 text-center mt-2"><h3>門市：{{this.$route.params.storename}}</h3></div>
            <div class="col-md-4 text-center mt-2"><h3>月份：{{this.$route.params.month}}</h3></div>
            <div class="col-md-4 text-center mt-2"><h3>總金額：{{this.$route.params.total}}元</h3></div>
          </div>
          <div class="col-lg-12">
            <div class="row">
            <div class="col-lg-6">
              <h3></h3>
            </div>
            <div class="col-lg-12 mt-2">
              <div class="table-responsive">
                <table class="table table-bordred table-striped">
                  <thead>
                  <tr>
                    <th>項次</th>
                    <th>訂單</th>
                    <th>會員</th>
                    <th>消費總額</th>
                    <th>訂單日期</th>
                    <th>發票開立</th>
                    <th>統編/載具</th>
                    <th>訂單狀態</th>
                    <th>付款狀態</th>
                    <th>支付工具</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(x,index) in items" :key="x.Code">
                    <td>{{index + 1}}</td>
                    <td>{{x.Code}}</td>
                    <td>{{x.UserName}}</td>
                    <td>{{x.Total}}</td>
                    <td>{{x.CreatedAt|formatFullDate}}</td>
                    <td>{{x.InvoiceType==0? '無' : x.InvoiceType==1? '紙本' : x.InvoiceType==2? '手機條碼載具' : x.InvoiceType}}</td>
                    <td>{{x.InvoiceType==2?  x.MobileBarcode : x.TIN}}</td>
                    <td>{{x.ProcessType}}</td>
                    <td>{{x.Payed}}</td> 
                    <td>{{x.PaymentType}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="row" style="padding: 0 1rem">
                <b-pagination size="md" :total-rows="totalrows" v-model="currentPage" :per-page="perpage" @change="getinformationpamentitem"></b-pagination>
                <label style="margin:8px">{{startRowNum}}到{{endRowNum}}，總共 {{totalrows}}筆</label>
              </div>
            </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>

<script>
import { getFunctionPermission } from "../../../js/LoginUserFunction.js";
import { API_URL } from "../../../store/root";
import miniToastr from "mini-toastr";
import draggable from "vuedraggable";
import VModal from "vue-js-modal";
import axios from "axios";
miniToastr.init();
export default {
  components: {
    draggable
  },
  data() {
    return {
      API_URL: API_URL,
      items: [],
      currentPage: 1,
      perpage: 20,
      totalrows: 0,
      startRowNum: 0,
      endRowNum: 0,
      search: {} // 記錄查詢條件
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission("F23"); // 功能權限
    if (this.FunctionPermission >= 2) {
    } else {
      if (this.FunctionPermission === 1) {
        this.$router.push({ name: 'information_payment_list' })
      } else {
        this.$router.push({ name: 'name' })
      }
    }
    this.search = this.$route.params.search
    this.getinformationpamentitem(1);
  },
  methods: {
    getinformationpamentitem(currentPage) {
      if (this.search === undefined) {
        this.$router.push({ name: 'information_payment_list' })
        return
      }
      this.$parent.Loading = true;
      return axios
        .post(API_URL + "/web/information/paymentitem/v1", {
          month: this.$route.params.month,
          store: this.$route.params.storeid,
          payment: this.$route.params.search.payment,
          toPage: currentPage,
          perPage: this.perpage
        })
        .then(response => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.items = response.data.data;
             this.totalrows = (response.data.count === undefined) ? 0 : response.data.count
            this.currentPage = currentPage
            this.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.perpage * (this.currentPage - 1) + 1
            this.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.perpage > response.data.count) ? response.data.count : (this.currentPage * this.perpage) >= response.data.count ? response.data.count : this.currentPage * this.perpage
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            this.items = [];
            miniToastr.error(response.data.message, "資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch(error => {
          this.items = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    }
  },filters: {
    formatFullDate: function(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var mon =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      return year + "/" + mon + "/" + day + " " + hour + ":" + min;
    }
  }
};
</script>
<style scoped>



// WEBPACK FOOTER //
// src/pages/information/payment/ItemList.vue